
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careerdetails",
      function () {
        return require("private-next-pages/careerdetails/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/careerdetails"])
      });
    }
  